import { memo } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

type PrintProvisionsProps = {
  provisions: string[];
};

export const PrintProvisions = memo(({ provisions }: PrintProvisionsProps) => {
  const { t } = useTranslation('insurance-eligibility-report');
  if (!provisions || provisions.length === 0) {
    return null;
  }

  return (
    <div css={provisionsCardStyles}>
      <Heading level={2} css={headerStyles}>
        {t('Provisions')}
      </Heading>
      <div css={unorderedListStyles}>
        <ul>
          {provisions.map((value, index) => {
            return (
              <Text as='li' key={(value || '') + index}>
                {value}
              </Text>
            );
          })}
        </ul>
      </div>
    </div>
  );
});

PrintProvisions.displayName = 'PrintProvisions';

const headerStyles = css`
  padding: 2px 0 0 ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
  border-bottom: 1px solid ${theme.colors.neutral20};
`;

const provisionsCardStyles = css`
  flex: 1;
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.medium};
`;

const unorderedListStyles = css`
  padding: ${theme.spacing(2)};
  padding-left: ${theme.spacing(1)};
`;
